import axios from 'axios';

window.axios = axios;

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
window.axios.defaults.headers.options ??= {};
window.axios.defaults.headers.options.Accept = 'application/json';
